import React, { useEffect, useState } from "react";
import { getReferredByUsers } from "../callable-cloud-functions/cloudFunctions";
import DateGeneric from "../components/custom-ui/old-ui/DateGeneric";
import { csvDownload } from "../components/dashboard/AdminMetricDashboard/ExportCsv";
import DownloadIconWithLabel from "../components/dashboard/AdminMetricDashboard/DownLoadIcon";
import { useLookupActive } from "../data/lookup";

function UsersByReferredBy() {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [referredBy, setReferredBy] = useState("");
  const [loadingStates, setLoadingStates] = useState({
    loading: false,
  });
  const { data: partners = [] } = useLookupActive("partner");

  const handleDownload = async (loadingKey, fileName) => {
    setLoadingStates((prev) => ({ ...prev, [loadingKey]: true }));

    if (!startDate || !endDate) {
      alert("Please select both start and end dates.");
      setLoadingStates((prev) => ({ ...prev, [loadingKey]: false }));
      return;
    }

    if (!referredBy) {
      alert("Please select referredBy value.");
      setLoadingStates((prev) => ({ ...prev, [loadingKey]: false }));
      return;
    }

    if (startDate.getTime() >= endDate.getTime()) {
      alert("Please select a valid date range (start must be before end).");
      setLoadingStates((prev) => ({ ...prev, [loadingKey]: false }));
      return;
    }

    try {
      console.log(
        "Downloading referredBy data from",
        startDate.getTime(),
        "to",
        endDate.getTime(),
        "for",
        referredBy
      );

      const response = await getReferredByUsers({
        startDate: startDate.getTime(),
        endDate: endDate.getTime(),
        referredBy,
      });

      const { data, fileName: fetchedFileName } = response.data;

      if (!data.length) {
        alert("No data found in the selected range.");
        return;
      }

      csvDownload(data, fetchedFileName || fileName);
    } catch (error) {
      console.error("Error during download:", error);
      alert("Something went wrong while downloading the data.");
    } finally {
      setLoadingStates((prev) => ({ ...prev, [loadingKey]: false }));
    }
  };

  return (
    <div className="w-full bg-[#E6F1FC] shadow-lg rounded-lg overflow-hidden">
      <div className="flex flex-wrap items-center justify-left text-xl font-extrabold text-[#1E596D] mb-4 p-3 border-b border-gray-300">
        Users By Referral Source
      </div>
      {/* Date Range Picker & Download Button */}
      <div className="flex flex-wrap gap-2 items-end px-4 pb-4 justify-right">
        <div className="w-50">
          <DateGeneric
            name="startDate"
            display="From Date"
            value={startDate}
            onChange={setStartDate}
            timestamp={true}
            required
            dateLimit="past"
          />
        </div>
        <div className="w-50">
          <DateGeneric
            name="endDate"
            display="To Date"
            value={endDate}
            onChange={setEndDate}
            timestamp={true}
            required
            dateLimit="past"
          />
        </div>
        <div className="w-50">
          <select
            className="border border-[#1E596D] w-100 mr-100 bg-white rounded-lg p-2 text-[#1E596D]"
            value={referredBy}
            onChange={(e) => setReferredBy(e.target.value)}
          >
            <option value="" disabled>
              Select Referral Source
            </option>
            {partners.map((partner, index) => (
              <option className="bg-white p-2" key={index} value={partner.code}>
                {partner.label}
              </option>
            ))}
          </select>
        </div>
        <div className="flex items-end">
          <p className="text-[#1E596D] text-[12px]">
            Download Referral Source Users List
          </p>
          <div className="flex mt-3 items-end">
            <div
              className="ml-3"
              onClick={() => handleDownload("loading", "users_referredBy")}
            >
              {loadingStates.loading ? (
                <p className="text-sm text-[#15404e]">Downloading...</p>
              ) : (
                <DownloadIconWithLabel
                  tooltipText="Download users from selected date range and referredBy."
                  viewDown={true}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UsersByReferredBy;
